import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import '../../styles/ScheduleContainer/ScheduleHeader.scss';
import Dropdown from 'shared/components/Dropdown';
import BtnSecondary from 'shared/components/Button/BtnSecondary';
import timezoneOptions from 'shared/constants/timezones';
import { Form } from '@ant-design/compatible';
import { Col, Row, notification, Popover } from 'antd';
import {DownloadOutlined,UploadOutlined} from '@ant-design/icons';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as userTypes from 'shared/constants/userTypes';
import * as eventRoleTypes from 'shared/constants/eventRoleTypes';
import { rowProps } from 'utils/rowHelpers';
import EditEventDetailsModal from './EditEventDetailsModal';
import EditEventScheduleSettingsModal from './EditEventScheduleSettingsModal';
import UploadScheduleModal from './UploadScheduleModal';
import Button from 'shared/components/Button/BtnPrimary';
import { handleEventTimeZoneUpdate, setEventDateChanged } from 'features/EventContainer/redux/actions/eventActions';
import { downloadScheduleCsv } from 'utils/services/schedules';
import { clearExportEventSchedule } from 'features/EventContainer/redux/actions/exportScheduleActions';
import { fetchPrograms } from 'features/AdminDashboard/redux/actions/programsActions';
import { PROGRAM_NAMES } from 'features/AdminDashboard/redux/constants';
import ResetSchedulerModal from 'shared/components/ResetSchedule';
import { ImportScheduleEntriesAction } from 'features/EventContainer/redux/actions/importScheduleEntriesAction';
import { handleResetSession } from 'features/EventContainer/redux/actions/resetScheduleAction';
import handleOpeningSession from 'features/EventContainer/redux/actions/scheduleActions/scheduleOpeningSession';
import handleClosingSession from 'features/EventContainer/redux/actions/scheduleActions/scheduleClosingSession';
import { fetchJudgingSessions } from 'features/EventContainer/redux/actions/scheduleActions/scheduleJudgingSessions';
import { fetchScoringSessions } from 'features/EventContainer/redux/actions/scheduleActions/scheduleScoringSessions';
import handleGetJudgingPanels from 'features/EventContainer/redux/actions/judgingActions/getJudgingPanels';
import { handleGetScoringPanelsNew } from 'features/EventContainer/redux/actions/scoringActions/getScoringPanels';


const { Option } = Dropdown;

const ScheduleHeader = (props) => {
  const {
    userType,
    userEventRoleIds,
    time_zone,
    handleTimezoneUpdate,
    isChangingTimeZone,
    eventScheduleId,
    eventProgramId,
    programList,
    fetchPrograms,
    importScheduleEntries,
    resetScheduleSession,
    fetchOpeningSession,
    fetchClosingSession,
    getJudgingSessions,
    getScoringSessions,
    getJudgingPanels,
    getScoringPanels,
  } = props;
  const { t } = useTranslation()

  const [visible, setVisible] = useState(false);
  const [scheduleVisible, setScheduleVisible] = useState(false);
  const [uploadingsScheduleVisible, setUploadingsScheduleVisible] = useState(false);
  const [resetVisible, setResetVisible] = useState(false);
  const [isReseting, setIsReseting] = useState(false);
  const [downloadingSchedule, setDownloadingSchedule] = useState(false);
  const dispatch = useDispatch();

   useEffect(() => {
    fetchPrograms();
   }, []);

     const downloadCsv = async () => {
    if (downloadingSchedule){
      return
    }

    setDownloadingSchedule(true)
    try {
      let data = await downloadScheduleCsv(eventScheduleId)
      const url = window.URL.createObjectURL(new Blob([data], {
        type: "text/csv"
      }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'schedule.csv')
      document.body.appendChild(link)
      link.click()
      setDownloadingSchedule(false)
    } catch (err) {
      notification.error({
        message: 'Error',
        description: err.description || err.message,
      });
      setDownloadingSchedule(false)
    }    
  }


  const openScheduleSettings = () => {
    setScheduleVisible(true);
  }

  const closeScheduleSettings = () => {
    setScheduleVisible(false);
  }
  const openUploadScheduler = () => {
    setUploadingsScheduleVisible(true);
  }

  const closeUploadScheduler = () => {
    setUploadingsScheduleVisible(false);
    dispatch(clearExportEventSchedule());
  }

  const openModal = () => {
    setVisible(true)
  }

  const closeModal = () => {
    setVisible(false)
  }

  const openResetScheduler = async() => {
     // download :false, resetSchedule:true
     await fetchTemplateData(false, true);
    setResetVisible(true);
  }
  const cancelReset = () => {
    setResetVisible(false); 
    setIsReseting(false);
  }

    const resetCallback = async() => { 
      setIsReseting(false);
      setResetVisible(false);
      notification.success({
        message: 'Schedule Reset',
        description: 'The schedule has been reset successfully.',
      });
      //get refresh panels after reset schedule
      await getJudgingPanels(eventScheduleId);
      await getScoringPanels(eventScheduleId);
      ScueessCallback();

  }

  const handleResetScheduler = () => {
    setIsReseting(true);
    resetScheduleSession(resetCallback);  
  }

  const fetchTemplateData = async (isDownloading,isResetSchedule) => {
        let data = "";
        try 
        {
          data=  await importScheduleEntries(isDownloading,isResetSchedule);
            return data;
  
        } catch (error) {
          closeModal();
          console.error("Error in fetching Schedule", error);
          notification.error({
            message: 'Schedule Error',
            description: `Error fetching Schedule`,
          });
         
        }
      };

const ScueessCallback = async() => { 
    setTimeout(() => {
      fetchOpeningSession(eventScheduleId);
      fetchClosingSession(eventScheduleId);
      getJudgingSessions(eventScheduleId);
      getScoringSessions(eventScheduleId);
    }, 100);
    
  }

  const PanelCallback = async() => {
     await getJudgingPanels(eventScheduleId);
     await getScoringPanels(eventScheduleId);
    
     //flag isEventDateChanged set to false
     dispatch(setEventDateChanged(false));

  }

  const isAdminUser = userType === userTypes.PARTNER_ADMIN || userType === userTypes.FIRST_ADMIN;

  const canEditEvent = isAdminUser || userEventRoleIds.includes(eventRoleTypes.EVENT_ADMIN_ID);
  const isJudgeAdvisorOrHeadRef= userEventRoleIds.includes(eventRoleTypes.JUDGE_ADVISOR_ID) ||  userEventRoleIds.includes(eventRoleTypes.HEAD_REFEREE_ID);

  const Program = programList.find(program => program.id === eventProgramId);

  const isProgramActive = Program?.name?.trim() === PROGRAM_NAMES.FLL || Program?.name?.trim() === PROGRAM_NAMES.JFLL;
  
  const onTimeZoneChanged = (value) => {
    handleTimezoneUpdate(value);
  }

  return (

  <div>
      <div className='event-schedule-header'>
        <EditEventDetailsModal visible={visible} onCancel={closeModal} />
        <EditEventScheduleSettingsModal visible={scheduleVisible} onCancel={closeScheduleSettings} />
        <UploadScheduleModal visible={uploadingsScheduleVisible} onCancel={closeUploadScheduler} successBack={ScueessCallback} panelBack={PanelCallback} />
        <ResetSchedulerModal visible={resetVisible} onCancel={cancelReset} onSubmit={handleResetScheduler}loading={isReseting} />
        <div className='event-schedule-header__right'>
          <Form style={{ width: '100%' }}>
            <Row {...rowProps} justify={canEditEvent ? "space-between" : 'start'}>
              <Col xs={isJudgeAdvisorOrHeadRef ? 12 : 24} md={isJudgeAdvisorOrHeadRef ? 8 : 5}>
                <Form.Item>
                  <Dropdown
                    disabled={true}
                    showArrow={false}
                    showSearch
                    value={time_zone ? time_zone : undefined}
                    onChange={onTimeZoneChanged}
                    loading={isChangingTimeZone}
                    placeholder="Select Timezone"
                  >
                    {timezoneOptions.map(tz => (
                      <Option value={tz.id} key={tz.id}>{tz.description}</Option>
                    ))}
                  </Dropdown>

                </Form.Item>
              </Col>
              {canEditEvent ? (
                <Col xs={24} md={5}>
                  <Form.Item>
                    <BtnSecondary size='medium' onClick={openModal}>
                      {t('editGeneralInfoLabel')}
                    </BtnSecondary>

                  </Form.Item>
                </Col>
              ) : null}
              {canEditEvent ? (
                <Col xs={24} md={4}>
                  <Form.Item>
                    <Button size='medium' onClick={openScheduleSettings}>
                      {t('autoScheduleBtnLabel')}
                    </Button>

                  </Form.Item>
                </Col>
              ) : null}
              {(isAdminUser || canEditEvent) && (
                <Col xs={24} md={5}>
                  <Form.Item>
                    <Button disabled={!isProgramActive} size='medium' onClick={openUploadScheduler}>
                   {t('customScheduleBtnLabel')}
                    </Button>

                  </Form.Item>
                </Col>
              )}
               {(isAdminUser || canEditEvent) && (
                <Col xs={24} md={4}>
                  <Form.Item>
                    <Button disabled={!isProgramActive} size='medium' onClick={openResetScheduler}>
                    {t('resetScheduleLabel')}
                    </Button>

                  </Form.Item>
                </Col>
              )}

              {(isAdminUser || canEditEvent) && (
                <Col xs={24} md={1}>
                  <Popover title={null} content={t('downloadLabel')}>
                    <span onClick={() => downloadCsv()} style={{ fontSize: 25, color: '#0066B3' }}>
                      <DownloadOutlined type={downloadingSchedule ? 'loading' : 'download'}  />
                    </span>
                  </Popover>
                </Col>
              )}
            </Row>

          </Form>
        </div>
      </div>
      <h1 className='heading--charcoal h-1'>{t('scheduleLabel')}</h1>
  </div>
  );
};
ScheduleHeader.propTypes = {
  userType: PropTypes.string.isRequired,
  userEventRoleIds: PropTypes.array.isRequired,
  fetchPrograms: PropTypes.func.isRequired,
  importScheduleEntries: PropTypes.func.isRequired,
  resetScheduleSession: PropTypes.func.isRequired,
  fetchOpeningSession: PropTypes.func.isRequired,
  fetchClosingSession: PropTypes.func.isRequired,
  getJudgingSessions: PropTypes.func.isRequired,
  getScoringSessions: PropTypes.func.isRequired,
  getJudgingPanels: PropTypes.func.isRequired,
  getScoringPanels: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  const {

    event: { eventDetails },
    auth: { userType },
     adminBoard: { programs: { list } }
  } = state;
  
  const { userEventRoleIds, time_zone, isChangingTimeZone, eventScheduleId,eventProgramId } = eventDetails;

  return {
    userType,
    userEventRoleIds,
    time_zone,
    isChangingTimeZone,
    eventScheduleId,
    eventProgramId,
    programList: list
  };
};

const mapDispatchToProps = {
  handleTimezoneUpdate: handleEventTimeZoneUpdate,
  fetchPrograms: fetchPrograms,
  importScheduleEntries:ImportScheduleEntriesAction,
  resetScheduleSession:handleResetSession,
  fetchOpeningSession:handleOpeningSession,
  fetchClosingSession:handleClosingSession,
  getJudgingSessions:fetchJudgingSessions,
  getScoringSessions:fetchScoringSessions,
  getJudgingPanels:handleGetJudgingPanels,
  getScoringPanels:handleGetScoringPanelsNew,
}

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleHeader);
